<template>
  <holiday-component/>
</template>

<script>
import HolidayComponent from '@/spa/components/board/holiday/BoardHoliday';

export default {
  name: 'HolidayPage',
  components: {
    HolidayComponent,
  },
};
</script>



// WEBPACK FOOTER //
// src/spa/pages/operation/HolidayPage.vue